import type { JssStyle } from 'jss';
import type { WebWidgetEntity } from '@web/types';
import type { MapWidgetData } from '@web/widgets/map/type/map-widget.type';

export function getStyles({}: WebWidgetEntity<MapWidgetData>): JssStyle {
    return {};
}
